import {useSelector} from "react-redux";

const useAuth = () => useSelector(state => state.auth.accessToken);

export default useAuth